import axios from "axios"   
import {
    GET_USERS,
    GET_USERS_PAGE,
    GET_USER_ROUTES,
    USER_CREATE_EDNPOINT,
    USER_UPDATE_EDNPOINT,
    GET_USER, GET_USER_BY_EMAIL
} from "../../utils/endpoints/userEndpoint";

export const login = async (token: string) => {
    try {
        const response = await axios.get(GET_USER, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return null;
    }
};
export const user_routes = () => {return axios.post(GET_USER_ROUTES);}
export const user_create=(name:string,mail:string,password :string,status:boolean)=>{

    return axios.post(USER_CREATE_EDNPOINT,{
       name, mail,password,status
    });     
}

export const postGetUserByEmail = (authToken: string) => {
    return axios.post(
        GET_USER_BY_EMAIL,
        {
            headers: {
                'Authorization': `Bearer ${authToken}`, // Aquí agregas el token de autorización
                'Content-Type': 'application/json', // Asegúrate de especificar el tipo de contenido
            }
        }
    );
};



export const user_update=(id:string,name:string,mail:string,password :string,status:boolean)=>{
    return axios.put(USER_UPDATE_EDNPOINT,{
        id, name, mail,password,status
    });     
}

export const get_users=()=>{return axios.get(GET_USERS)}

export const get_users_pag=(page?:number,size?:number,name?:string,mail?:string,status?:number)=>{
    
        return axios.get(GET_USERS_PAGE(name,mail,page,size,status))


}